import { Switch } from '@platform/design-system';
import type { Product } from '../product.ts';
import type { StatusChange } from './product-actions.tsx';

export type ActiveSwitchProps = {
  readonly product: Product;
  readonly label: string;
  readonly busy: boolean;
  readonly onStatus: (change: StatusChange, products: readonly Product[]) => void;
};

export const ActiveSwitch = ({ product, label, busy, onStatus }: ActiveSwitchProps) => {
  if (product.status === 'archived') return <span aria-hidden="true">—</span>;
  const isActive = product.status === 'active';
  return (
    <Switch
      label={label}
      labelDisplay="hidden"
      checked={isActive}
      disabled={busy}
      onChange={() => {
        onStatus(isActive ? 'deactivate' : 'publish', [product]);
      }}
    />
  );
};
